/**
 * Check if any critical flight data is invalid (null or undefined)
 * @param flights - Array of flights to validate
 * @returns true if all critical flight data is valid, false otherwise
 */
export const validateRequiredFlightData = flights => {
  return !flights.some(flight => {
    return !flight.departureDateTime || !flight.departureCity && !flight.departureAirportName || !flight.arrivalDateTime || !flight.arrivalCity && !flight.arrivalAirportName || !flight.duration;
  });
};
/**
 * Calculate the total flight duration including stay times
 * @returns total flight duration in minutes, or null if any flight has invalid duration
 */
export const calculateTotalFlightDuration = flights => {
  if (flights.some(flight => !flight.duration)) return null;
  return flights.reduce((accumulator, flight) => {
    return accumulator + (flight.duration || 0) + (flight.stayTime || 0);
  }, 0);
};